'use client';

import { useEffect, useMemo } from 'react';
import Navbar from './navbar/Navbar';
import { useLocale } from 'next-intl';
import Alerts from './top-header/alerts';
import MainHeader from './navbar/MainHeader';
import CheckoutHeader from './checkout-header';
import { usePathname } from '@/i18n/navigation';
import ShippingInfoModal from '@/components/ui/modals/shipping/shipping-info-modal';
import CartPopup from '@/components/cart/cart-popup';
import { shouldShowMainLayout } from '@/utils/global';
import { useSession } from 'next-auth/react';
import { getCookie } from 'cookies-next/client';
import { setCookie } from 'cookies-next';
// import { signOutHandler } from '@/utils/auth';

const Header = ({ headerData, isMobile }) => {
  const locale = useLocale();
  const { data: session } = useSession();
  const headerItems = useMemo(() => {
    const get = (key) =>
      headerData?.find((item) => item?.active && item?.key === key) || {};
    return {
      alerts: get('alerts'),
      contactInfo: get('contact-info'),
      links: get('links'),
    };
  }, [headerData]);
  const pathname = usePathname();
  const { alerts, links } = headerItems;
  const showMainBlocks = shouldShowMainLayout(pathname);

  useEffect(() => {
    if (session?.user?.id) {
      const mage = getCookie('mage');
      if (!mage || mage === 'undefined') {
        setCookie('mage', session?.mage, { expires: new Date(session?.expires) });
      }
    }
    // const mage = getCookie('mage');
    // if (mage && mage !== 'undefined') {
    //   const isSessionExist = session && session?.user?.id === undefined
    //   if (isSessionExist) {
    //     signOutHandler()
    //     signOut({ callbackUrl: '/login' })
    //   }
    // }
  }, [session]);

  return (
    <header className='upper-part top-0 right-0 left-0 z-50 w-full bg-white max-sm:sticky'>
      {showMainBlocks ? (
        <>
          <Alerts data={alerts} locale={locale} isMobile={isMobile} />
          <MainHeader />
          <Navbar links={links} isMobile={isMobile} />
          {pathname !== '/cart' && <CartPopup />}
        </>
      ) : (
        <CheckoutHeader />
      )}

      <ShippingInfoModal />
    </header>
  );
};

export default Header;
